import React from'react';

const n=v=>v==null||v===''||!Number.isFinite(Number(v))?null:Number(v);
const money=v=>{const x=n(v);if(x==null)return'—';return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD',notation:'compact',maximumFractionDigits:2}).format(x)};
const pct=v=>n(v)==null?'—':(Number(v)>=0?'+':'')+Number(v).toFixed(1)+'%';
const label=v=>String(v||'MISSING').replaceAll('_',' ');
const tone=v=>String(v||'review').toLowerCase().replaceAll('_','-');

export default function TenXResearchPanel({evidence}){
 const e=evidence||{};
 const pillars=[
  ['Scale room',e.scale],
  ['Forward growth',e.growth],
  ['Cash',e.cash],
  ['Quality',e.quality],
  ['Insider',e.insider]
 ];
 return <section className={'tenx-panel tenx-'+tone(e.state)}><div className="section-head compact"><div><small>10X RESEARCH FILTER</small><h2>{label(e.state)}</h2></div><span>{e.status||'REVIEW'} · prioritization, not prediction</span></div><div className="tenx-metrics"><div><small>Approx. market cap</small><b>{money(e.marketCapApprox)}</b><span>{e.sharesOutstandingAsOf?'SEC shares as of '+e.sharesOutstandingAsOf:'SEC shares date missing'}</span></div><div><small>Forward revenue growth</small><b>{pct(e.forwardRevenueGrowthPct)}</b><span>{e.analystCount==null?'Analyst count missing':Number(e.analystCount).toFixed(0)+' analyst(s)'}</span></div></div><div className="tenx-pillars">{pillars.map(([k,v])=><div key={k}><small>{k}</small><b>{label(v)}</b></div>)}</div>{Array.isArray(e.reasons)&&e.reasons.length?<ul>{e.reasons.map((r,i)=><li key={i}>{r}</li>)}</ul>:null}<p>{e.note||'10x evidence is not available.'}</p></section>;
}
